// The country (or region) behind each currency code, so a bare token code like
// BOPb reads "BOPb (Bolivia)". One map for every admin page. A code that isn't
// here shows on its own.
const COUNTRIES = {
  AED: "UAE", AFN: "Afghanistan", ALL: "Albania", AMD: "Armenia", ANG: "Curaçao", AOA: "Angola",
  ARS: "Argentina", AUD: "Australia", AWG: "Aruba", AZN: "Azerbaijan", BAM: "Bosnia and Herzegovina",
  BBD: "Barbados", BDT: "Bangladesh", BGN: "Bulgaria", BHD: "Bahrain", BIF: "Burundi", BMD: "Bermuda",
  BND: "Brunei", BOB: "Bolivia", BOP: "Bolivia", BRL: "Brazil", BSD: "Bahamas", BTN: "Bhutan",
  BWP: "Botswana", BYN: "Belarus", BZD: "Belize", CAD: "Canada", CDF: "DR Congo", CHF: "Switzerland",
  CLP: "Chile", CNY: "China", COP: "Colombia", CRC: "Costa Rica", CUC: "Cuba", CUP: "Cuba", CVE: "Cape Verde",
  CZK: "Czechia", DJF: "Djibouti", DKK: "Denmark", DOP: "Dominican Republic", DZD: "Algeria",
  EGP: "Egypt", ERN: "Eritrea", ETB: "Ethiopia", EUR: "Euro area", FJD: "Fiji", FKP: "Falkland Islands", GBP: "United Kingdom",
  GEL: "Georgia", GGP: "Guernsey", GHS: "Ghana", GIP: "Gibraltar", GMD: "Gambia", GNF: "Guinea", GTQ: "Guatemala", GYD: "Guyana",
  HKD: "Hong Kong", HNL: "Honduras", HRK: "Croatia", HTG: "Haiti", HUF: "Hungary", IDR: "Indonesia", ILS: "Israel", IMP: "Isle of Man",
  INR: "India", IQD: "Iraq", IRR: "Iran", ISK: "Iceland", JEP: "Jersey", JMD: "Jamaica", JOD: "Jordan", JPY: "Japan",
  KES: "Kenya", KGS: "Kyrgyzstan", KHR: "Cambodia", KMF: "Comoros", KPW: "North Korea", KRW: "South Korea", KWD: "Kuwait",
  KYD: "Cayman Islands", KZT: "Kazakhstan", LAK: "Laos", LBP: "Lebanon", LKR: "Sri Lanka",
  LRD: "Liberia", LSL: "Lesotho", LYD: "Libya", MAD: "Morocco", MDL: "Moldova", MGA: "Madagascar",
  MKD: "North Macedonia", MMK: "Myanmar", MNT: "Mongolia", MOP: "Macao", MRU: "Mauritania",
  MUR: "Mauritius", MVR: "Maldives", MWK: "Malawi", MXN: "Mexico", MYR: "Malaysia", MZN: "Mozambique",
  NAD: "Namibia", NGN: "Nigeria", NIO: "Nicaragua", NOK: "Norway", NPR: "Nepal", NZD: "New Zealand",
  OMR: "Oman", PAB: "Panama", PEN: "Peru", PGK: "Papua New Guinea", PHP: "Philippines", PKR: "Pakistan",
  PLN: "Poland", PYG: "Paraguay", QAR: "Qatar", RON: "Romania", RSD: "Serbia", RUB: "Russia",
  RWF: "Rwanda", SAR: "Saudi Arabia", SBD: "Solomon Islands", SCR: "Seychelles", SDG: "Sudan",
  SEK: "Sweden", SGD: "Singapore", SHP: "Saint Helena", SLE: "Sierra Leone", SLL: "Sierra Leone", SOS: "Somalia",
  SRD: "Suriname", SSP: "South Sudan", STN: "São Tomé and Príncipe", SVC: "El Salvador", SYP: "Syria",
  SZL: "Eswatini", THB: "Thailand", TJS: "Tajikistan", TMT: "Turkmenistan", TND: "Tunisia", TOP: "Tonga",
  TRY: "Turkey", TTD: "Trinidad and Tobago", TWD: "Taiwan", TZS: "Tanzania", UAH: "Ukraine",
  UGX: "Uganda", USD: "United States", UYU: "Uruguay", UZS: "Uzbekistan", VED: "Venezuela", VES: "Venezuela",
  VND: "Vietnam", VUV: "Vanuatu", WST: "Samoa", XAF: "Central Africa", XCD: "Eastern Caribbean", XCG: "Curaçao",
  XOF: "West Africa", XPF: "French Pacific", YER: "Yemen", ZAR: "South Africa", ZMW: "Zambia",
  ZWG: "Zimbabwe", ZWL: "Zimbabwe",
};

// "BOPb", "BOP" or the legacy "BC-BOP" -> "Bolivia". null when the code isn't known.
export const currencyCountry = (symbol) => {
  const code = String(symbol || "").trim().replace(/^BC-/i, "").replace(/b$/, "").toUpperCase();
  return COUNTRIES[code] || null;
};

// "BOPb" -> "BOPb (Bolivia)", or the code alone when the country isn't known.
export const withCountry = (symbol) => {
  const country = currencyCountry(symbol);
  return country ? `${symbol} (${country})` : String(symbol || "");
};
